<template>
  <router-view></router-view>
</template>

<script>
import HomeView from "@/views/HomeView.vue";
import ResultView from "@/views/ResultView.vue";

export default {
  name: "App",
  components: {
    HomeView,
    ResultView,
  },
  mounted() {
    document.title = "NeuralStyle";
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  background-image: url("./assets/bg.png");
  background-size: auto;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #53789c;
}
</style>
